import { GeoJson } from '@ais-ui/api-spec/shapes';
import { SelectType } from '@ais-ui/ui-core';
import { Bookmark, Filter, Group } from '@ais-ui/websockets';
import { EventdetectorDefinition } from '@ais-ui/api-spec/eventdetector';
import { AtoN, ShipList } from '@ais-ui/api-spec/config';
import { GroundingConfigurationSchema } from '@ais-ui/api-spec/grounding';

export const grabShapeInitialGroups = (
  shape: GeoJson | undefined,
  groups: Group[] | null | undefined
): SelectType[] => {
  const acl = shape?.properties.acl || [];

  const matchingGroups =
    groups?.filter(
      (group) => acl.includes(group.uuid) || acl.includes(group.name)
    ) || [];

  let initialGroupSelectables: SelectType[] = [];
  if (matchingGroups) {
    initialGroupSelectables = matchingGroups.map((group) => ({
      label: group.name,
      value: group.uuid,
    }));
  }

  return initialGroupSelectables;
};

export const grabFilterInitialGroups = (
  filter: Filter | undefined,
  groups: Group[] | null | undefined
): SelectType[] => {
  const filterGroups = filter?.groups || [];

  const matchingGroups =
    groups?.filter(
      (group) =>
        filterGroups.includes(group.uuid) || filterGroups.includes(group.name)
    ) || [];

  let initialGroupSelectables: SelectType[] = [];
  if (matchingGroups) {
    initialGroupSelectables = matchingGroups.map((group) => ({
      label: group.name,
      value: group.uuid,
    }));
  }

  return initialGroupSelectables;
};

export const grabEventDetectorInitialGroups = (
  eventDetector:
    | EventdetectorDefinition
    | GroundingConfigurationSchema
    | undefined,
  groups: Group[] | null | undefined
): SelectType[] => {
  const eventDetectorGroups = eventDetector?.acl || [];

  const matchingGroups =
    groups?.filter(
      (group) =>
        eventDetectorGroups.includes(group.uuid) ||
        eventDetectorGroups.includes(group.name)
    ) || [];

  let initialGroupSelectables: SelectType[] = [];
  if (matchingGroups) {
    initialGroupSelectables = matchingGroups.map((group) => ({
      label: group.name,
      value: group.uuid,
    }));
  }

  return initialGroupSelectables;
};

export const grabShiplistInitialGroups = (
  shiplist: ShipList | undefined,
  groups: Group[] | null | undefined
): SelectType[] => {
  const shiplistGroups = shiplist?.acl || [];

  const matchingGroups =
    groups?.filter(
      (group) =>
        shiplistGroups.includes(group.uuid) ||
        shiplistGroups.includes(group.name)
    ) || [];

  let initialGroupSelectables: SelectType[] = [];
  if (matchingGroups) {
    initialGroupSelectables = matchingGroups.map((group) => ({
      label: group.name,
      value: group.uuid,
    }));
  }

  return initialGroupSelectables;
};

export const grabAtonInitialGroups = (
  aton: AtoN | undefined,
  groups: Group[] | null | undefined
): SelectType[] => {
  const atonGroups = aton?.groups || [];

  const matchingGroups =
    groups?.filter(
      (group) =>
        atonGroups.includes(group.uuid) || atonGroups.includes(group.name)
    ) || [];

  let initialGroupSelectables: SelectType[] = [];
  if (matchingGroups) {
    initialGroupSelectables = matchingGroups.map((group) => ({
      label: group.name,
      value: group.uuid,
    }));
  }

  return initialGroupSelectables;
};

export const grabBookmarkInitialGroups = (
  bookmark: Bookmark | undefined,
  groups: Group[] | null | undefined
): SelectType[] => {
  const bookmarkGroups = bookmark?.acls || [];

  const matchingGroups =
    groups?.filter(
      (group) =>
        bookmarkGroups.includes(group.uuid) ||
        bookmarkGroups.includes(group.name)
    ) || [];

  let initialGroupSelectables: SelectType[] = [];
  if (matchingGroups) {
    initialGroupSelectables = matchingGroups.map((group) => ({
      label: group.name,
      value: group.uuid,
    }));
  }

  return initialGroupSelectables;
};
